<div class="ctr" [class.open]="IsOpening">
  <svg id="arrow" width="30" height="20">
    <line x1="0" y1="10" x2="30" y2="10" style="stroke-width: 1" [style.stroke]="TextColor" />;
    <line id="top-arrow" x1="22" y1="10" x2="30" y2="10" style="stroke-width: 1; " [style.stroke]="TextColor" />;
    <line id="bottom-arrow" x1="22" y1="10" x2="30" y2="10" style="stroke-width: 1; "
      [style.stroke]="TextColor" />;
  </svg>
</div>

